/* eslint-disable no-bitwise, operator-assignment -- PRNG (mulberry32) exige bit-twiddling literal */

/** PRNG determinístico (mulberry32) — semeado pela empresa, cena pixel-estável. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export const seedFrom = (n: number, salt = 0): number => (n * 2654435761 + salt * 40503) >>> 0;

/** Inteiro em [0, n). */
export const randInt = (rnd: () => number, n: number): number => Math.floor(rnd() * n);

/** Escolhe um item do array de forma estável. */
export function pick<T>(rnd: () => number, arr: readonly T[]): T {
  return arr[randInt(rnd, arr.length)];
}
